// Aggregate parent + sub-campaigns into a single object for display.
// Metadata (goal, dates, description, pledgingEnabled, etc.) is kept from the parent;
// only the dollar/count fields the displays use are summed. The campaignsList
// endpoint returns per-campaign rows — a parent's own row excludes any
// sub-campaign that appears in the same response — so displays showing a
// campaign-wide total must sum the rows client-side with this.
export const rollUpCampaignWithSubCampaigns = (campaign, subCampaigns) => {
  if (!campaign || !subCampaigns?.length) return campaign;
  const sumField = (field) =>
    (campaign[field] || 0) +
    subCampaigns.reduce((acc, sub) => acc + (sub?.[field] || 0), 0);
  return {
    ...campaign,
    unpledgedAmountGiven: sumField("unpledgedAmountGiven"),
    pledgedAmountGiven: sumField("pledgedAmountGiven"),
    totalPledge: sumField("totalPledge"),
    unpledgedRecurring: sumField("unpledgedRecurring"),
    // Rides along with the projection it is netted against — see
    // Designations/campaignTotals.js.
    unpledgedRecurringAmountGiven: sumField("unpledgedRecurringAmountGiven"),
    pledgesCount: sumField("pledgesCount"),
  };
};
